export enum ImageCopyright {
    None = "None",
    Rapidparts = "Rapidparts",
    Mcfa = "Mcfa",
}
